module.exports = __webpack_public_path__ + "static/media/cluster-userflow-2.9a5cd8a3.jpg";